<template>
  <div :class="cssDate(d)" v-for="(d, idx) in filterWeek" :key="idx">
    <p class="date" style="font-size:0.9em;">{{ d.month }}/{{ d.date }}</p>
    <p class="day">{{ d.wd }}</p>
  </div>
</template>

<script>
export default {
  name: "AppointmentWeek",
  props: ["week", "weekdates"],
  data() {
    return {};
  },
  computed: {
    filterWeek() {
      //console.log(this.weekdates);
      return this.weekdates.filter($w => $w.week === this.week);
    }
  },
  methods: {
    cssDate(d) {
      let css = `dateBox d${d.day}`;
      if (!d.enable) css += " disable";
      if (d.today) css += " active";
      return css;
    }
  }
};
</script>
